module.exports = __webpack_public_path__ + "static/img/9.3bd694d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/9.jpg
// module id = wiGM
// module chunks = 0